exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orderStatusPage-main{width:100%;min-height:100vh;align-items:center;justify-content:center}.orderStatusPage-main,.orderStatusPage-content,.orderStatusPage-info{display:flex}.orderStatusPage-content{justify-content:space-between;width:80%;height:100%}.orderStatusPage-info{flex-direction:column;justify-content:space-between;width:50%}@media screen and (max-width: 960px){.orderStatusPage-main{align-items:flex-start;box-sizing:border-box;justify-content:flex-start;padding:3vw}.orderStatusPage-content{flex-direction:column;width:100%}.orderStatusPage-info{width:100%}}\n", ""]);

// exports
